import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Billing Subscribe Page - Pay-Per-Use Model
 * 
 * Note: Subscriptions are no longer available. This page now shows
 * information about the pay-per-use pricing model.
 */
const BillingSubscribe = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center p-4">
      <div className="max-w-2xl w-full bg-gray-800 rounded-lg shadow-xl p-8">
        <div className="text-center mb-8">
          <div className="text-6xl mb-4">💳</div>
          <h1 className="text-3xl font-bold text-white mb-2">
            Pay-Per-Use Pricing
          </h1>
          <p className="text-gray-400 text-lg">
            No subscriptions. Pay only when you launch.
          </p>
        </div>

        <div className="space-y-6 mb-8">
          {/* Created Game Launches */}
          <div className="bg-gray-700 rounded-lg p-6">
            <h2 className="text-xl font-semibold text-white mb-3 flex items-center">
              <span className="text-green-400 mr-2">✓</span>
              Launch Your Created Games
            </h2>
            <div className="text-3xl font-bold text-white mb-2">$15</div>
            <p className="text-gray-300 mb-4">per launch</p>
            <ul className="space-y-2 text-gray-300 text-sm">
              <li className="flex items-start">
                <span className="text-green-400 mr-2">•</span>
                <span>12-hour launch window included</span>
              </li>
              <li className="flex items-start">
                <span className="text-green-400 mr-2">•</span>
                <span>No monthly limits or quotas</span>
              </li>
              <li className="flex items-start">
                <span className="text-green-400 mr-2">•</span>
                <span>Pay only when you launch</span>
              </li>
            </ul>
          </div>

          {/* Marketplace Games */}
          <div className="bg-gray-700 rounded-lg p-6">
            <h2 className="text-xl font-semibold text-white mb-3 flex items-center">
              <span className="text-green-400 mr-2">✓</span>
              Purchase Marketplace Games
            </h2>
            <div className="text-3xl font-bold text-white mb-2">$35+</div>
            <p className="text-gray-300 mb-4">base price + $15 launch fee</p>
            <ul className="space-y-2 text-gray-300 text-sm">
              <li className="flex items-start">
                <span className="text-green-400 mr-2">•</span>
                <span>Minimum $20 base price (set by creator)</span>
              </li>
              <li className="flex items-start">
                <span className="text-green-400 mr-2">•</span>
                <span>$15 launch fee (always included)</span>
              </li>
              <li className="flex items-start">
                <span className="text-green-400 mr-2">•</span>
                <span>1 launch right included with purchase</span>
              </li>
              <li className="flex items-start">
                <span className="text-green-400 mr-2">•</span>
                <span>12-hour launch window</span>
              </li>
            </ul>
          </div>

          {/* Free Features */}
          <div className="bg-gray-700 rounded-lg p-6">
            <h2 className="text-xl font-semibold text-white mb-3 flex items-center">
              <span className="text-green-400 mr-2">✓</span>
              Always Free
            </h2>
            <ul className="space-y-2 text-gray-300 text-sm">
              <li className="flex items-start">
                <span className="text-green-400 mr-2">•</span>
                <span>Create unlimited games</span>
              </li>
              <li className="flex items-start">
                <span className="text-green-400 mr-2">•</span>
                <span>Submit games to marketplace (unlimited)</span>
              </li>
              <li className="flex items-start">
                <span className="text-green-400 mr-2">•</span>
                <span>Access to analytics and tools</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex gap-4">
          <button
            onClick={() => navigate('/marketplace')}
            className="flex-1 bg-green-600 hover:bg-green-700 text-white font-semibold py-3 px-6 rounded-lg transition-colors duration-200"
          >
            Browse Marketplace
          </button>
          <button
            onClick={() => navigate('/home')}
            className="flex-1 bg-gray-700 hover:bg-gray-600 text-white font-semibold py-3 px-6 rounded-lg transition-colors duration-200"
          >
            Go to Dashboard
          </button>
        </div>

        <div className="mt-6 text-center">
          <p className="text-gray-400 text-sm">
            Questions? Check out our <a href="/faq" className="text-green-400 hover:underline">FAQ</a> or <a href="/helpdesk" className="text-green-400 hover:underline">contact support</a>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default BillingSubscribe;
